// import React from "react";
// import DashboardLayout from "../../layouts/DashboardLayout";
// import { Navigate } from "react-router-dom";

// const AuthLayout = (props) => {
//   // console.log("Local Storage Admin Info:", localStorage.getItem("adminInfo"));

//   return (
//     <React.Fragment>
//       <DashboardLayout>{props.children}</DashboardLayout>
//     </React.Fragment>
//   );
// };

// export default AuthLayout;


import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AdminLayout from './AdminLayout';
import SupplierLayout from './SupplierLayout';

const AuthLayout = ({ children }) => {
  const { isAuthenticated, isAdmin, isSupplier, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  // Check if current path matches user role
  const currentPath = window.location.pathname;

  // Admin trying to access seller routes
  if (isAdmin && currentPath.startsWith('/seller/')) {
    return <Navigate to="/dashboard" replace />;
  }

  // Seller trying to access admin routes
  if (isSupplier && !currentPath.startsWith('/seller/')) {
    return <Navigate to="/seller/dashboard" replace />;
  }

  // Render Admin Layout for admin users
  if (isAdmin) {
    return <AdminLayout>{children}</AdminLayout>;
  }

  // Render Supplier Layout for supplier users
  if (isSupplier) {
    return <SupplierLayout>{children}</SupplierLayout>;
  }

  // Fallback - redirect to login if role is not determined
  return <Navigate to="/admin-login" replace />;
};

export default AuthLayout;